import { ErrorOutline } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { isPast } from "date-fns";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import FormatISODate from "../../../../../../global/FormatISODate";
import HNSColors from "../../../../../../ui library/HNSColors";
import { STRINGS } from "../utils/string";

import ActionItemClient from "./ActionItemClient";
import ActionItemLawFirm from "./ActionItemLawFirm";
import ActionItemManual from "./ActionItemManual";
import ActionItemProvider from "./ActionItemProvider";

export default function ActionItem({
  item,
  actionItemType,
  setActiveActionItem,
  setOpenAddActionItemModal,
  setOpenCompleteModal,
}) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const getTextColor = () => {
    return item?.priority > 0 || item?.priorityDate
      ? HNSColors.primary[200]
      : HNSColors.neutrals[100];
  };

  const getItemType = (type) => {
    switch (type) {
      case 1:
        return <ActionItemClient item={item} />;
      case 2:
        return <ActionItemProvider item={item} />;
      case 3:
        return <ActionItemLawFirm item={item} />;
      case 4:
        return <ActionItemManual item={item} />;
      default:
        return <ActionItemManual item={item} />;
    }
  };

  const getFollowUpFormRoute = () => {
    return "/form/" + item?.id;
  };

  const getBgColor = () => {
    return item?.priority > 0 || item?.priorityDate
      ? HNSColors.tertiary[900]
      : HNSColors.neutrals[900];
  };

  const mouseEnterHandler = () => {
    setIsHovered(true);
  };

  const mouseLeaveHandler = () => {
    setIsHovered(false);
  };

  const clickHandler = () => {
    if (item?.status === "pending" && parseInt(item?.formCount) > 0) {
      navigate(getFollowUpFormRoute());
      return;
    }

    setActiveActionItem(item);

    if (item?.status === "done") {
      setOpenCompleteModal(true);
    } else {
      setOpenAddActionItemModal(true);
    }
  };

  return (
    <div className="mb-2 border-b-2">
      <div
        className="mb-2 h-[70px] w-full cursor-pointer rounded-md p-2"
        style={{
          backgroundColor: isHovered ? HNSColors.tertiary[800] : getBgColor(),
        }}
        onClick={() => clickHandler()}
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
      >
        <div className="flex w-full text-xs capitalize">
          <div
            className="relative w-[90%]"
            style={{
              color: getTextColor(),
            }}
          >
            <div className="h-[50px]">{getItemType(actionItemType)}</div>
            <div className="absolute bottom-0 text-xs">
              <span className="font-bold">DUE: </span>
              {item?.dueDate ? (
                <span className="lowercase">
                  {FormatISODate(item?.dueDate)} {"(" + item?.relativeDueDate + ")"}
                </span>
              ) : (
                STRINGS.NO_DUE_DATE_AVAILABLE
              )}
            </div>
          </div>
          <div className="w-[10%] text-right">
            {isPast(new Date(item?.dueDate)) && (
              <Tooltip title={STRINGS.PAST_DUE}>
                <ErrorOutline className="text-[1rem] text-red-600" />
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
